import App from './App';

export default App;


// WEBPACK FOOTER //
// ./src/Components/App/index.tsx